
import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { NavigationEnd, Router, RouterModule } from "@angular/router";
import { filter } from "rxjs";
import { Title } from "@angular/platform-browser";
import { SessionService } from "../../../../Utils/_services/session/session.service";
import { TooltipModule } from 'primeng/tooltip';

interface SidebarItem {
  label: string;
  icon: string;
  route: string;
}

@Component({
  selector: "app-sidebar",
  standalone: true,
  imports: [RouterModule, TooltipModule],
  templateUrl: "./sidebar.component.html",
  styleUrl: "./sidebar.component.css",
})
export class SidebarComponent implements OnInit {
  constructor(
    private titleService: Title,
    private router: Router,
    private sessionService: SessionService
  ) { }

  @Input() collapsed: boolean = false;
  @Output() toggleSidebar = new EventEmitter<void>();
  currentRoute = "";
  callCount = 0; // placeholder — update this from a service when available

  menuItems: SidebarItem[] = [
    { label: "Dashboard", icon: "pi pi-th-large", route: "/admin/dashboard" },
    { label: "Lobbies", icon: "pi pi-comments", route: "/admin/lobbies" },
    { label: "Users", icon: "pi pi-users", route: "/admin/users" },
    { label: "Waitlisted User", icon: "pi pi-list", route: "/admin/waitlisted-user" },
    { label: "Verification Requests", icon: "pi pi-plus-circle", route: "verification-requests" },

    {
      label: "Themes",
      icon: "fa-solid fa-paint-roller",
      route: "/admin/themes",
    },
    {
      label: "Generic Questions",
      icon: "pi pi-question-circle",
      route: "/admin/generic-questions",
    },
    {
      label: "Partners",
      icon: "fa-regular fa-handshake",
      route: "/admin/partners",
    },
    { label: "Logs", icon: "fa-solid fa-box", route: "/admin/logs" },
    {
      label: "Violation Reports",
      icon: "pi pi-link",
      route: "/admin/violation-report",
    },
    { label: "Notification Management", icon: "pi pi-bell", route: "/admin/notification-management" },
    { label: "Payments Transactions", icon: "pi pi-wallet", route: "/admin/payment-transactions" },
    { label: "Subscription Management", icon: "pi pi-credit-card", route: "/admin/subscription-management" },
    { label: "Brand Images", icon: "pi pi-images", route: "/admin/brand-images" },
    { label: "Achievements", icon: "pi pi-trophy", route: "/admin/achievements" },
    { label: "Settings", icon: "pi pi-cog", route: "/admin/settings" },
  ];

  ngOnInit() {
    // Track route changes
    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        this.currentRoute = event.url;
      });

    // Set initial route
    this.currentRoute = this.router.url;
  }

  isActive(route: string): boolean {
    return this.currentRoute === route || this.currentRoute.startsWith(route);
  }

  onToggleSidebar() {
    this.toggleSidebar.emit();
  }

  setTitle(label: string) {
    this.titleService.setTitle(label);
  }
}
